/* unplugin-vue-components disabled */import { render } from "./News.vue?vue&type=template&id=1e3b3081&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=1e3b3081&lang=scss&scoped=true"
import "./News.vue?vue&type=style&index=1&id=1e3b3081&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/外网-成都工业学院-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3b3081"]])

export default __exports__